import { Box, Divider, Stack } from '@mui/material'
import { Notifications, UserInfo } from './modules'
import { styles } from './styles'

export const Header = () => {
  return (
    <Stack direction={'column'} sx={styles.headerWrap}>
      <Stack sx={styles.header}>
        <Box></Box>
        <Stack direction={'row'} alignItems={'center'} gap={'16px'}>
          <Stack direction={'row'} alignItems={'center'}>
            {/* <Search /> */}
            <Notifications />
          </Stack>
          <UserInfo />
        </Stack>
      </Stack>
      <Divider sx={{ margin: '8px 0', width: '100%' }} />
    </Stack>
  )
}
